<template>
  <div>

    <v-dialog max-width="500" persistent v-model="dialog">
      <v-card class="pa-5">
        <p>
          Please provide a description of the problem. Your feedback will be submitted along with the card you are currently studying.
        </p>
        <v-spacer></v-spacer>
        <v-textarea outlined label="Feedback" v-model="feedback">

        </v-textarea>
        <div class="text-right">
          <v-btn class="mr-3" @click="cancel()">Cancel</v-btn>
          <v-btn color="blue" dark @click="submitFeedback()">Submit</v-btn>


        </div>


      </v-card>



    </v-dialog>

  </div>

</template>

<script>
import firebase from 'firebase'

export default {
  name: 'ReportProblem',
  props: [

  ],
  watch: {

  },
  data() {
    return {
      dialog: false,
      feedback: null,
      card: null,
      uid: null,
      email: null,
      os: navigator.appVersion,
      name: this.$store.state.userData.firstname + " " + this.$store.state.userData.lastname,
      htmlRender: null
    }
  },
  methods: {
    openDialog(input) {
      this.$store.commit('enableHotkeysSet', false)
      this.card = input
      this.feedback = null
      this.dialog = true
      this.uid = firebase.auth().currentUser.uid
      this.email = firebase.auth().currentUser.email
      this.htmlRender = JSON.stringify(document.getElementById("learning-content").innerHTML)
    },
    submitFeedback() {
      firebase.firestore().collection('feedback').doc().set({
        card: this.card,
        timestamp: new Date(),
        uid: this.uid,
        email: this.email,
        feedback: this.feedback,
        os: this.os,
        name: this.name,
        htmlRender: this.htmlRender

      }).then(() => {
        this.dialog = false
        this.$store.commit('enableHotkeysSet', true)
        this.$store.commit('snackbarMessageSet', {
          color: 'blue lighten-2',
          message: 'Thank you for your feedback.'
        })
      })
    },
    cancel() {
      this.dialog = false
      this.$store.commit('enableHotkeysSet', true)
    }
  }
}
</script>
